module.exports = __webpack_public_path__ + "static/img/projectDetail_1.c27543f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mainPage/projectDetail_1.jpg
// module id = O7Kx
// module chunks = 0